<template>
  <div style="padding-bottom: 60px">
    <!-- <template v-if="!fromPage">
      <g-title title="会员信息确认" class="c-p-20"></g-title>
      <van-form ref="infoFormRef">
        <van-field
          v-model="formData.MobilePhone"
          :disabled="!!memberId"
          type="tel"
          name="MobilePhone"
          maxlength="11"
          label="手机号"
          placeholder="请输入手机号"
          :error="false"
          :rules="[{ required: true, message: '请输入手机号' }]"
        >
          
        </van-field>
      
        <van-field
          v-model="formData.MemberName"
          maxlength="50"
          name="MemberName"
          label="会员姓名"
          placeholder="请输入姓名"
          :error="false"
          :rules="[{ required: true, message: '请输入姓名' }]"
        />
        <van-field name="SexId" label="会员性别">
          <template #input>
            <van-radio-group v-model="formData.SexId" direction="horizontal">
              <van-radio :name="1">男</van-radio>
              <van-radio :name="2">女</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          readonly
          clickable
          name="Birthday"
          :value="formData.Birthday"
          label="会员生日"
          placeholder="请选择生日"
          @click="showBirthPicker = true"
        />
        <van-popup
          v-model="showBirthPicker"
          position="bottom"
          get-container="#app"
        >
          <van-datetime-picker
            type="date"
            v-model="currentDate"
            :min-date="dateMinDate"
            :max-date="dateMaxDate"
            @confirm="onConfirm"
            @cancel="showBirthPicker = false"
          />
        </van-popup>

      </van-form>
    </template> -->
    <g-title
      :title="fromPage == 'recharge' ? '会员卡信息确认' : '购买项目确认'"
      class="c-p-tb-10 c-p-lr-20"
    ></g-title>
    <card-list-com
      :cardList="allCardList"
      :fromPage="fromPage ? fromPage : 'pay'"
      :rechargeMoney="rechargeMoney"
    >
    </card-list-com>
    <g-line></g-line>
    <card-pay-com
      :origMoney="allPayMoney"
      fromPage="noCardPay"
      ref="payComRef"
    ></card-pay-com>
    <div class="c-fl-bt btm c-font-34">
      <div class="b-l">
        <div>
          <span>合计:</span>
          <span class="c-yang">￥</span>
          <span>{{ allPayMoney }}</span>
          <span v-if="favourMoney != 0" class="c-font-20"
            >（优惠￥{{ favourMoney }})</span
          >
        </div>
      </div>
      <div class="b-r c-f-ar">
        <div @click="confirmBuy">确认支付</div>
      </div>
    </div>
  </div>
</template>

<script>
import { handleSessionStorage, dateFormat } from "@/utils";
import cardPayCom from "@/components/PayComps/cardPayGroup.vue";
import cardListCom from "@/components/cardListCom";
import {
  getUserCardInfo,
  submitPayEleCard,
  getRechargePayMoney,
} from "@/api/member";
import { setToken } from "@/utils/auth";

export default {
  name: "CardPay",
  props: {},
  components: {
    cardPayCom,
    cardListCom,
  },
  data() {
    return {
      fromPage: undefined,
      memberId: undefined,
      allCardList: [],
      rechargeMoney: 0,
      currentDate: new Date(),
      dateMinDate: new Date(1900, 0, 1),
      dateMaxDate: new Date(),
      formData: {
        MemberName: "",
        SexId: 1,
        MobilePhone: "",
        Birthday: "",
        // SmsCode: "",
      },
      codeDiabled: true,
      showBirthPicker: false,
      allPayMoney: 0,
      favourMoney: 0,
      isSubmiting: false,
      cardTypeCode:''
    };
  },
  created() {
    this.fromPage = this.$route.query.fromPage || undefined;
    this.vpnId = this.$store.state.vpnId;
    this.handleGetUserInfo();
    this.rechargeMoney = this.$route.query.cardPayMoney;
    this.allPayMoney = this.$route.query.allPayMoney;
    this.cardTypeName = this.$route.query.cardTypeName;
    this.cardTypeId = this.$route.query.cardTypeId;
    this.cardTypeCode = this.$route.query.cardTypeCode;
    this.rechargeInfo = this.$store.state.eleCard.rechargeInfoObj;
    const cardTypeObj = this.$store.state.eleCard.cardTypeObj;
    this.secondaryCardList = this.$store.state.eleCard.secondaryCardList;
    console.log("888888888888888-----------------");
    console.log(this.$store.state);
    if (cardTypeObj && cardTypeObj.Id) {
      this.allCardList = [cardTypeObj];
    }
    if (this.secondaryCardList.length > 0) {
      this.allCardList = this.allCardList.concat(this.secondaryCardList);
    }
    console.log(this.allCardList);
    this.handleGetAllPrice();
  },
  mounted() {},
  // watch: {
  //   "formData.MobilePhone"(val) {
  //     if (val.length === 11) {
  //       this.codeDiabled = false;
  //     } else {
  //       this.codeDiabled = true;
  //     }
  //   },
  // },
  methods: {
    handleGetUserInfo() {
      getUserCardInfo({ vpnId: this.vpnId }).then((res) => {
        if (res && !res.Code) {
          if (res.Token) {
            setToken(res.Token);
          }
          this.formData = {
            MemberName: res.MemberName,
            SexId: res.SexId,
            MobilePhone: res.MobilePhone,
            Birthday: res.Birthday ? res.Birthday.split(" ")[0] : "",
          };
          this.memberId = res.Id;
        }
      });
    },
    handleGetAllPrice() {
      const timeCard = this.secondaryCardList.map((item) => {
        return {
          Id: item.Id,
          Count: 1,
        };
      });
      getRechargePayMoney({
        vpnId: this.vpnId,
        RechargeSettlement: {
          RechargeMoney: this.rechargeInfo.Id ? 0 : this.rechargeMoney,
          RechargeReceipt: this.rechargeInfo.Id ? null : this.rechargeMoney,
          CardSellPlan: this.rechargeInfo,
          TimesCardPlans: timeCard,
        },
      }).then((res) => {
        this.allPayMoney = res.FactPayMoney;
        this.favourMoney = res.FavourMoney;
      });
    },
    // handleGetCode() {
    //   $http(
    //     "wechath5/zh-cn/v1/member/sendsmscode?phone=" +
    //       this.formData.MobilePhone
    //   ).then((res) => {
    //     this.$toast("发送验证码成功");
    //     this.$refs.sendRef.activeCode();
    //   });
    // },
    onConfirm(time) {
      this.formData.Birthday = dateFormat(time, "yyyy/MM/dd");
      this.showBirthPicker = false;
    },
    async confirmBuy() {
      const _this = this;
      // if (!this.fromPage) {
      //   this.$refs.infoFormRef.validate().then((res) => {
      //     if (!res) {
      //       handleCommit();
      //     }
      //   });
      // } else {
      handleCommit();
      // }

      function handleCommit() {
        if (_this.isSubmiting) {
          _this.$toast("正在请求中,请稍后");
          return;
        }
        // 次卡
        const timeCard = _this.secondaryCardList.map((item) => {
          return {
            Id: item.Id,
            Count: 1,
            Money: item.Money,
            RealMoney: item.RealMoney,
          };
        });
        let rechargeAndCiCardObj = {
          RechargeMoney: _this.rechargeInfo.Id ? 0 : _this.rechargeMoney, //充值金额
          RechargeReceipt: _this.rechargeInfo.Id ? null : _this.rechargeMoney,
          CardSellPlan: _this.rechargeInfo, //充值方案
          TimesCardPlans: timeCard, //次卡购买
        };
        const memberCardInfo = handleSessionStorage.get("cardItemInfo");
        const param = {
          VpnId: _this.vpnId,
          CardTypeId: _this.cardTypeId,
          CardTypeName: _this.cardTypeName,
          MemberId: !_this.fromPage
            ? null
            : memberCardInfo && memberCardInfo.Id, //单独充值或单独办次卡时才传
          // // DefaultPassword:,
          RechargeSettlement: rechargeAndCiCardObj,
          ProfileDTO: {
            Id: _this.memberId,
            ..._this.formData,
          },
        };
        _this.isSubmiting = true;
        submitPayEleCard(param)
          .then((res) => {
            _this.isSubmiting = false;
            // handleLocalStorage.remove("cardTypeObj");
            // handleLocalStorage.remove("secondaryCardList");
            _this.$store.commit("eleCard/setCardTypeInfo", {});
            _this.$store.commit("eleCard/setSecondaryCardList", []);
            _this.$store.commit("eleCard/setRechargeInfo", {});
            const { Id, SequenceId } = res;
            if (_this.$refs.payComRef.radio == "wechat") {
              _this.$pub.wechatPay(SequenceId, _this.allPayMoney * 100, {
                orderId: Id,
                payType: _this.$store.state.vpnInfo.payType,
                payAfterUrl: "MyMemberCard", //微信原生支付成功后返回的页面
                sqbAfterUrl: "member/myMemberCard", //收钱吧支付成功后返回的页面
              });
            } else {
              _this.$refs.payComRef.handlePayByCard(_this.allPayMoney, Id);
            }
          })
          .catch(() => {
            _this.isSubmiting = false;
          });
      }
    },
  },
};
</script>
<style scoped lang="scss">
.btm {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 96px;
  background: #ffffff;
  box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.02);
  box-sizing: border-box;
  width: 100%;

  .b-l {
    margin-left: 20px;
  }
  .b-r {
    width: 200px;
    background: var(--tc);
    height: 100%;
    color: #fff;
  }
}
</style>
